import { baseApi, extractData } from "../api/axiosConfig";

export const getAllContractDataPointValueFilters = () =>
    baseApi
        .get("/contractDataPointValueFilter")
        .then(extractData);

export const addContractDataPointValueFilter = data =>
    baseApi
        .post("/contractDataPointValueFilter", data)
        .then(extractData);

export const editContractDataPointValueFilter = (contractDataPointValueFilterId, data) =>
    baseApi
        .put(`/contractDataPointValueFilter/${contractDataPointValueFilterId}`, data)
        .then(extractData);

export const deleteContractDataPointValueFilter = contractDataPointValueFilterId =>
    baseApi
        .delete(`/contractDataPointValueFilter/${contractDataPointValueFilterId}`)
        .then(extractData);

export const getContractDataPointValueFilterById = contractDataPointValueFilterId =>
    baseApi
        .get(`/contractDataPointValueFilter/${contractDataPointValueFilterId}`)
        .then(extractData);

export const getCDPVFbyCDPid = contractDataPointId =>
    baseApi
        .get("/contractDataPointValueFilter/getCDPVFbyCDPid", {
            params: {
                cdp_id: contractDataPointId
            }
        })
        .then(extractData);

export const updateCdpvfHierarchy = cdpId =>
    baseApi
        .get("/contractDataPointValueFilter/hierarchy", {
            params: {
                cdp_id: cdpId
            }
        })
        .then(extractData);

export const updateCdpvfMockValueAdd = () =>
    baseApi
        .get("/contractDataPointValueFilter/mockAdd")
        .then(extractData);

export const updateCdpvfMockValueEdit = cdpvfId =>
    baseApi
        .get("/contractDataPointValueFilter/mockEdit", {
            params: {
                my_cdpvf_id: cdpvfId
            }
        })
        .then(extractData);

export const addNewFilterLevel = (cdpId, fromValue, toValue) =>
    baseApi
        .get("/contractDataPointValueFilter/addFilterLevel", {
            params: {
                my_cdp_id: cdpId,
                my_from_value: fromValue,
                my_to_value: toValue
            }
        })
        .then(extractData);

export const extendLastFilterLevel = (cdpId, toValue) =>
    baseApi
        .get("/contractDataPointValueFilter/extendLastFilterLevel", {
            params: {
                my_cdp_id: cdpId,
                my_to_value: toValue
            }
        })
        .then(extractData);


// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// export const getAllContractDataPointValueFilters = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addContractDataPointValueFilter = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/contractDataPointValueFilter`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const editContractDataPointValueFilter = (selectorContractDataPointValueFilterId, data) =>
//     axios.put(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/${selectorContractDataPointValueFilterId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//             console.log("this is the PUT data I submitted");
//             console.log(data);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteContractDataPointValueFilter = selectorContractDataPointValueFilterId =>
//     axios.delete(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/${selectorContractDataPointValueFilterId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getContractDataPointValueFilterById = (contractDataPointValueFilterId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/${contractDataPointValueFilterId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCDPVFbyCDPid = (contractDataPointId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/getCDPVFbyCDPid`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {cdp_id: contractDataPointId}
//             // axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/contractDataPointId`,
//             //     {
//             //         params: {contractDataPointId: contractDataPointId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const updateCdpvfHierarchy = (cdp_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/hierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {cdp_id: cdp_id}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const updateCdpvfMockValueAdd = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/mockAdd`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const updateCdpvfMockValueEdit = (my_cdpvf_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/mockEdit`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdpvf_id: my_cdpvf_id}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const addNewFilterLevel = (my_cdp_id, my_from_value, my_to_value) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/addFilterLevel`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: my_cdp_id,
//                 my_from_value: my_from_value,
//                 my_to_value: my_to_value}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const extendLastFilterLevel = (my_cdp_id,  my_to_value) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValueFilter/extendLastFilterLevel`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: my_cdp_id,
//                 my_to_value: my_to_value}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
